/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   .item[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:center}"];
export { styles as styles };
